import {LISTING_SECTION_IDS} from './listingSections.js'

export const ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME = 'ads-list-autocaravans-and-trailers'
export const ADS_LIST_BUGGIES_NEW_PAGE_NAME = 'ads-list-buggies-new'
export const ADS_LIST_BUGGIES_PAGE_NAME = 'ads-list-buggies'
export const ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME = 'ads-list-cars-without-license'
export const ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME = 'ads-list-classic-and-competition'
export const ADS_LIST_MINIMOTOS_NEW_PAGE_NAME = 'ads-list-minimotos-new'
export const ADS_LIST_MINIMOTOS_PAGE_NAME = 'ads-list-minimotos'
export const ADS_LIST_NEW_PAGE_NAME = 'ads-list-new'
export const ADS_LIST_PAGE_NAME = 'ads-list'
export const ADS_LIST_QUADS_NEW_PAGE_NAME = 'ads-list-quads-new'
export const ADS_LIST_QUADS_PAGE_NAME = 'ads-list-quads'
export const ADS_LIST_SUBSCRIPTION_PAGE_NAME = 'ads-list-subscription'
export const ADS_LIST_BUSINESS_SUBSCRIPTION_PAGE_NAME = 'ads-list-business-subscription'
export const ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME = 'ads-list-vans-and-commercial'

export const ADS_LIST_PAGE_NAMES = {
  AUTOCARAVANS_AND_TRAILERS: ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME,
  BUGGIES_NEW: ADS_LIST_BUGGIES_NEW_PAGE_NAME,
  BUGGIES: ADS_LIST_BUGGIES_PAGE_NAME,
  CARS_WITHOUT_LICENSE: ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME,
  CLASSIC_AND_COMPETITION: ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  MAIN: ADS_LIST_PAGE_NAME,
  MINIMOTOS_NEW: ADS_LIST_MINIMOTOS_NEW_PAGE_NAME,
  MINIMOTOS: ADS_LIST_MINIMOTOS_PAGE_NAME,
  NEW: ADS_LIST_NEW_PAGE_NAME,
  QUADS_NEW: ADS_LIST_QUADS_NEW_PAGE_NAME,
  QUADS: ADS_LIST_QUADS_PAGE_NAME,
  SUBSCRIPTION: ADS_LIST_SUBSCRIPTION_PAGE_NAME,
  VANS_AND_COMMERCIAL: ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME
}

export const PAGE_NAMES_BY_LISTING_SECTION_ID = {
  [LISTING_SECTION_IDS.ALL_VEHICLES]: ADS_LIST_PAGE_NAME,
  [LISTING_SECTION_IDS.AUTOCARAVANS_AND_TRAILERS_VEHICLES]: ADS_LIST_AUTOCARAVANS_AND_TRAILERS_PAGE_NAME,
  [LISTING_SECTION_IDS.BUGGIES_NEW_VEHICLES]: ADS_LIST_BUGGIES_NEW_PAGE_NAME,
  [LISTING_SECTION_IDS.BUGGIES_SECOND_HAND_VEHICLES]: ADS_LIST_BUGGIES_PAGE_NAME,
  [LISTING_SECTION_IDS.BUGGIES_VEHICLES]: ADS_LIST_BUGGIES_PAGE_NAME,
  [LISTING_SECTION_IDS.CLASSIC_AND_COMPETITION_VEHICLES]: ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  [LISTING_SECTION_IDS.CLASSIC_MOTOS_VEHICLES]: ADS_LIST_CLASSIC_AND_COMPETITION_PAGE_NAME,
  [LISTING_SECTION_IDS.KM0_VEHICLES]: ADS_LIST_PAGE_NAME,
  [LISTING_SECTION_IDS.MINIMOTOS_NEW_VEHICLES]: ADS_LIST_MINIMOTOS_NEW_PAGE_NAME,
  [LISTING_SECTION_IDS.MINIMOTOS_SECOND_HAND_VEHICLES]: ADS_LIST_MINIMOTOS_PAGE_NAME,
  [LISTING_SECTION_IDS.MINIMOTOS_VEHICLES]: ADS_LIST_MINIMOTOS_PAGE_NAME,
  [LISTING_SECTION_IDS.NEW_VEHICLES]: ADS_LIST_NEW_PAGE_NAME,
  [LISTING_SECTION_IDS.NO_LICENSE_VEHICLES]: ADS_LIST_CARS_WITHOUT_LICENSE_PAGE_NAME,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_NEW_VEHICLES]: ADS_LIST_QUADS_NEW_PAGE_NAME,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_SECOND_HAND_VEHICLES]: ADS_LIST_QUADS_PAGE_NAME,
  [LISTING_SECTION_IDS.QUADS_AND_ATVS_VEHICLES]: ADS_LIST_QUADS_PAGE_NAME,
  [LISTING_SECTION_IDS.RENTING_VEHICLES]: ADS_LIST_SUBSCRIPTION_PAGE_NAME,
  [LISTING_SECTION_IDS.SECOND_HAND_VEHICLES]: ADS_LIST_PAGE_NAME,
  [LISTING_SECTION_IDS.VANS_AND_COMMERCIAL_VEHICLES]: ADS_LIST_VANS_AND_COMMERCIAL_PAGE_NAME
}

export const AD_DETAIL_RESERVATION_HASHES = {
  FAQ: '#reservation-faq',
  LOGIN: '#login',
  NOT_AVAILABLE: '#reservation-not-available',
  OPEN_DRAWER: '#open-reservation',
  WRONG_USER: '#reservation-wrong-user'
}
